import { useState, useCallback, useRef, useEffect } from "react";
import { getAuthHeaders } from "../../auth/services/getAuthHeaders";

export type TranscriptItem = { timestamp: string; orig: string; tran: string; isMic?: boolean };
export interface Meeting {
  _id: string | number;
  title: string;
  source_lang: string;
  target_lang: string;
  user_id: string;
  created_at: string;
}

export function useMeetings(translatorServiceUrl: string, recording: boolean) {
  const [meetingTranscript, setMeetingTranscript] = useState<TranscriptItem[]>([]);
  const [currentMeetingId, setCurrentMeetingId] = useState<string | null>(null);
  
  const [subtitleOrig, setSubtitleOrig] = useState("");
  const [subtitleTran, setSubtitleTran] = useState("");

  const addHistory = useCallback(
    (orig: string, tran: string, isMic = false) => {
      const now = new Date();
      const timestamp = now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" });
      const prefix = isMic ? "🎤 Yo: " : "";
      const newItem: TranscriptItem = { timestamp, orig: prefix + orig, tran: prefix + tran, isMic };

      setMeetingTranscript((prev) => [...prev, newItem]);

      // Guardar en base de datos si hay meeting_id
      if (currentMeetingId && translatorServiceUrl) {
        getAuthHeaders().then((headers) => {
          const cleanedUrl = translatorServiceUrl.replace(/\/$/, "");
          fetch(`${cleanedUrl}/meetings/${currentMeetingId}/transcripts`, {
            method: "POST",
            headers: { ...headers, "Content-Type": "application/json" },
            body: JSON.stringify({
              original_text: prefix + orig,
              translated_text: prefix + tran,
            }),
          }).catch((err) => console.error("Error al guardar segmento:", err));
        });
      }
    },
    [currentMeetingId, translatorServiceUrl]
  );

  const loadPastMeeting = useCallback(
    (meetingId: string, transcripts: TranscriptItem[], sourceLang: string, targetLang: string, setSrcLang: (l: string) => void, setTgtLang: (l: string) => void) => {
      setCurrentMeetingId(meetingId);
      setMeetingTranscript(transcripts);
      setSrcLang(sourceLang);
      setTgtLang(targetLang);

      if (transcripts.length > 0) {
        const last = transcripts[transcripts.length - 1];
        setSubtitleOrig(last?.orig ?? "");
        setSubtitleTran(last?.tran ?? "");
      } else {
        setSubtitleOrig("");
        setSubtitleTran("");
      }
    },
    []
  );

  return {
    meetingTranscript,
    setMeetingTranscript,
    currentMeetingId,
    setCurrentMeetingId,
    subtitleOrig,
    setSubtitleOrig,
    subtitleTran,
    setSubtitleTran,
    addHistory,
    loadPastMeeting,
  };
}
